import "./Tenders.module.css";
import Header from "@/reusable_sections/Header";
import Procurement from "./sections/Procurement";
import Methodology from "./sections/Methodology";
import Action from "./sections/Action";
import Footer from "@/reusable_sections/Footer";
export default function TendersPage() {
  return <div>
      <Header />
      <Procurement />
      <Methodology />
      <Action />
      <Footer />
    </div>;
}